
export interface ProductDescriptor {
  id?: string;
  name: string;
  value: string;
  order?: number;
}
